import { useQuery } from 'react-query';

// our api
import localAxiosInstance from 'services/API/LocalAPI';

// our query keys
import { KEY_ACTION_QUALIFIERS } from 'shared/query-keys';

// our endpoints
import { keyActionQualifiersUrl } from 'shared/api-urls';

// our constants
import { DEFAULT_STALE_TIME_FIVE_MINUTES } from 'shared/constants';

function useGetKeyActionQualifiers(select = (data) => data) {
	return useQuery(
		[KEY_ACTION_QUALIFIERS],
		async () => {
			const response = await localAxiosInstance.get(
				keyActionQualifiersUrl
			);

			return response.data;
		},
		{
			staleTime: DEFAULT_STALE_TIME_FIVE_MINUTES,
			select
		}
	);
}

export default useGetKeyActionQualifiers;
